@let content = copy();

@if (content) {
  <p-button severity="secondary"
            class="absolute inset-0 flex"
            styleClass="!h-full !w-full !rounded-none !border-0 !bg-(--p-neutral-500)/70 hover:!bg-(--p-neutral-500)/70 backdrop-blur-[3px]"
            [ariaLabel]="content.cancel | translate"
            (onClick)="cancel()"></p-button>

  <div class="relative m-[1.25rem] w-full rounded-[0.5rem] bg-(--p-surface-0) px-[1.25rem] py-[1.5rem] shadow-[0_0.25rem_1.5rem_0_var(--p-other-opacity-black-25)]"
       [class]="overlay() === Overlay.Hide ? 'max-w-[30rem]' : 'max-w-[26rem]'"
       role="alertdialog"
       aria-modal="true">
    <p-button icon="true"
              severity="contrast"
              rounded="true"
              class="absolute right-[1rem] top-[1rem] flex"
              styleClass="!size-[1.75rem] !px-0 !py-0 !bg-transparent !text-(--p-primary-200) hover:!text-(--p-primary-500) focus:!text-(--p-primary-500) !border-0"
              [text]="true"
              [ariaLabel]="'@@shared-close' | translate"
              (onClick)="cancel()">
      <svg-icon src="icons/icon-close-popup.svg" name="icon-close-popup"></svg-icon>
    </p-button>

    <div class="flex items-center gap-[0.625rem] pr-[2rem]">
      @if (content.icon) {
        <svg-icon class="block size-[1.25rem] shrink-0 text-(--p-primary-500)"
                  [src]="content.icon"
                  [name]="content.icon"></svg-icon>
      }

      <h3 class="text-[1rem] font-semibold leading-[150%] text-(--p-primary-500)">{{ content.title | translate }}</h3>
    </div>

    <p class="mt-[0.75rem] text-[0.75rem] leading-[150%] text-(--p-gray-950)" [translate]="content.body"></p>

    @if (overlay() === Overlay.Hide) {
      <p class="mt-[0.75rem] text-[0.75rem] leading-[150%] text-(--p-gray-950)"
         translate="@@fp-event-hide-prompt__body-filter"></p>

      <div class="mt-[1rem] rounded-[0.25rem] bg-(--p-neutral-500) px-[1rem] py-[0.875rem]">
        <p class="flex items-center gap-[0.375rem] text-[0.6875rem] leading-[150%] text-(--p-primary-300)">
          <span aria-hidden="true">&uarr;</span>
          <span translate="@@fp-event-hide-prompt__find-hint"></span>
        </p>

        <div class="mt-[0.75rem] inline-flex h-[1.75rem] shrink-0 cursor-default items-center gap-[0.375rem] rounded border-[1px] border-(--p-primary-100) bg-transparent px-[0.4375rem]"
             aria-hidden="true">
          <!-- a picture of the map's events filter, switched on: shown, not a field -->
          <p-toggleswitch class="pointer-events-none flex" styleClass="png-small" [ngModel]="true"/>

          <div class="flex gap-1">
            <div class="text-[0.6875rem] font-semibold text-(--p-gray-950)">
              <span translate="@@shared-events__text"></span><span>: </span><span translate="@@shared-all__text"></span>
            </div>

            <svg-icon src="icons/icon-dropdown-arrow-down.svg"
                      name="icon-dropdown-arrow-down"
                      class="!text-(--p-gray-500) pb-[0.125rem] shrink-0"></svg-icon>
          </div>
        </div>
      </div>
    }

    <div class="mt-[1.5rem] flex flex-wrap items-center justify-end gap-[0.75rem]">
      @if (overlay() === Overlay.Hide) {
        <div class="mr-auto flex items-center gap-[0.5rem]">
          <p-checkbox class="flex"
                      inputId="dialog-event-hide-dont-show-again"
                      [binary]="true"
                      [ngModel]="dontShowAgain()"
                      (ngModelChange)="dontShowAgain.set($event)">
            <ng-template #checkboxicon>
              @if (dontShowAgain()) {
                <svg-icon src="icons/icon-checkmark-correct.svg"
                          name="icon-checkmark-correct"
                          class="text-(--p-surface-0) size-[0.5rem] shrink-0"></svg-icon>
              }
            </ng-template>
          </p-checkbox>

          <label for="dialog-event-hide-dont-show-again"
                 class="cursor-pointer select-none text-[0.75rem] text-(--p-gray-950)"
                 translate="@@fp-event-hide-prompt__dont-show-again"></label>
        </div>
      }

      <div class="flex items-center gap-[0.25rem]">
        <p-button [outlined]="true"
                  styleClass="!h-[2rem] !px-[1.25rem] !rounded-[0.25rem] !border-(--p-primary-500) !text-(--p-primary-500)"
                  [label]="content.cancel | translate"
                  (onClick)="cancel()"></p-button>

        <p-button [severity]="content.destructive ? 'danger' : 'primary'"
                  styleClass="!h-[2rem] !px-[1.25rem] !rounded-[0.25rem]"
                  [label]="content.confirm | translate"
                  (onClick)="confirm()"></p-button>
      </div>
    </div>
  </div>
}
